import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element: Component }) => {
  const [showPrompt, setShowPrompt] = useState(false); // To control showing the prompt
  const [redirectToLogin, setRedirectToLogin] = useState(false); // For redirecting to login
  const [timeElapsed, setTimeElapsed] = useState(false); // Check if 10 mins have passed
  
  const SESSION_KEY = "story_reading_start_time"; // Key to store the start time

  // Check if the user is logged in
  const isLoggedIn = localStorage.getItem("idToken"); 

  // Check if 10 minutes have passed since the user started reading
  const checkTimeElapsed = () => {
    const startTime = localStorage.getItem(SESSION_KEY);
    if (startTime) {
      const currentTime = Date.now();
      const elapsedTime = currentTime - parseInt(startTime);
      if (elapsedTime >= 10 * 60 * 1000) { // 10 minutes in milliseconds
        setTimeElapsed(true);
      }
    }
  };

  // If user is not logged in and the time is greater than 10 mins, show the prompt
  useEffect(() => {
    if (!isLoggedIn) {
      checkTimeElapsed(); // Check time when the component mounts

      const intervalId = setInterval(() => {
        checkTimeElapsed();
      }, 1000); // Check every second

      return () => clearInterval(intervalId); // Cleanup interval on unmount
    }
  }, [isLoggedIn]);

  const handleLoginPrompt = () => {
    setShowPrompt(true);
  };

  const handleLogin = () => {
    setRedirectToLogin(true); // Redirect to login page
  };

  if (redirectToLogin) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      {isLoggedIn || !timeElapsed ? (
        Component // Show the component if user is logged in or time hasn't passed
      ) : (
        <div className="login-prompt">
          {showPrompt ? (
            <div className="prompt-message">
              <p>You've been reading for 10 minutes! Please log in to continue reading for free.</p>
              <button onClick={handleLogin}>Log in to Continue</button>
            </div>
          ) : (
            <div>
              <p>You are reading the story for free. Log in to continue reading without interruptions.</p>
              <button onClick={handleLoginPrompt}>Log in to Continue</button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ProtectedRoute;
